import { HomeComponent } from './modules/home/home.component';
import { noInternetComponent } from './template/noInternet/noInternet.component';
import { SearchComponent } from './modules/shared/search/search.component';
var appRoutes = [
    { path: '', component: HomeComponent },
    { path: 'user', loadChildren: 'app/modules/user/user.module#UserModule' },
    { path: 'faq', loadChildren: 'app/modules/faq/faq.module#FaqModule' },
    { path: 'about', loadChildren: 'app/modules/about/about.module#AboutModule' },
    { path: 'how-to-order', loadChildren: 'app/modules/how-to-order/how.module#HowToOrderModule' },
    { path: 'terms', loadChildren: 'app/modules/terms/terms.module#TermsModule' },
    { path: 'checkout', loadChildren: 'app/modules/checkout/checkout.module#CheckoutModule' },
    { path: 'address-book', loadChildren: 'app/modules/address/address.module#AddressModule' },
    { path: 'payments', loadChildren: 'app/modules/payments/payments.module#PaymentsModule' },
    { path: 'items', loadChildren: 'app/modules/items/items.module#ItemsModule' },
    { path: 'orders', loadChildren: 'app/modules/orders/orders.module#OrdersModule' },
    { path: 'no-internet', component: noInternetComponent },
    { path: 'search', component: SearchComponent },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts.pre-build-optimizer.js